<template>
    <div v-if="show" class="toast info-toast">
        <button class="toast-close" @click="closeToast"></button>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'rc-toast',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeToast() {
            this.$emit('update:show', false)
        }
    }
}
</script>
<style lang="scss" scoped>
.toast {
    position: fixed;
    left: 5px;
    right: 5px;
    bottom: 5px;
    padding: 10px 20px 5px 5px;
    ;
}

.danger-toast {
    background: #FFB0B0;
    border: 1px solid #FF0000;
    border-radius: 3px;
    color: #880000;

    & .toast-close::before,
    & .toast-close::after {
        background: #880000;
    }
}

.info-toast {
    background: #80B0FF;
    border: 1px solid #0000AA;
    border-radius: 3px;
    color: #000088;

    & .toast-close::before,
    & .toast-close::after {
        background: #000088;
    }
}

.toast-close {
    position: absolute;
    right: 3px;
    top: 8px;
    width: 15px;
    height: 15px;
    border: none;
    background: none;

    &::before,
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        width: 100%;
        height: 3px;
        border-radius: 1px;
    }

    &::before {
        transform: rotate(45deg);
    }

    &::after {
        transform: rotate(-45deg);
    }
}
</style>